import styled from "styled-components";

export const ConfirmDialogStyles = styled.div`
  background: ${({ theme }) => theme.colors.semantic.container.white};
  border-radius: ${({ theme }) => theme.radius[16]};
  padding: ${({ theme }) => theme.spacing[40]};
  padding-bottom: ${({ theme }) => theme.spacing[24]};
  width: 480px;
  max-width: calc(100vw - 32px);

  .confirmTitle {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.2px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin-bottom: ${({ theme }) => theme.spacing[12]};
  }

  .confirmMessage {
    font-size: ${({ theme }) => theme.typography.body.b1.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin-bottom: ${({ theme }) => theme.spacing[56]};
  }

  .confirmActions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${({ theme }) => theme.spacing[12]};

    button {
      padding: ${({ theme }) => `${theme.spacing[12]} ${theme.spacing[32]}`};
      border-radius: ${({ theme }) => theme.radius.rounded};
      font-size: ${({ theme }) => theme.typography.title.t1.size};
      font-weight: ${({ theme }) => theme.typography.title.t1.weight};
      cursor: pointer;
      transition: all 0.15s ease;
      border: none;
    }

    .cancelBtn {
      background: ${({ theme }) => theme.colors.semantic.container.gray};
      color: ${({ theme }) => theme.colors.semantic.text.strong};

      &:hover {
        background: ${({ theme }) => theme.colors.semantic.container.grayHover};
      }
    }

    .confirmBtn {
      background: ${({ theme }) => theme.colors.error[500]};
      color: #fff;

      &:hover {
        background: ${({ theme }) => theme.colors.error[600]};
      }
    }

    .confirmBtn.accent {
      background: ${({ theme }) => theme.colors.semantic.accent.default};

      &:hover {
        background: ${({ theme }) => theme.colors.semantic.accent.hover};
      }
    }
  }
`;
